export default __webpack_public_path__ + "static/media/about.4611e39d.jpg";